import { render, staticRenderFns } from "./PolimixProductionOffSpecStockDetail.vue?vue&type=template&id=10085ec7&"
import script from "./PolimixProductionOffSpecStockDetail.vue?vue&type=script&lang=js&"
export * from "./PolimixProductionOffSpecStockDetail.vue?vue&type=script&lang=js&"
import style0 from "./PolimixProductionOffSpecStockDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports